import { EXPORT_SERVICE_NAME, ExportServiceProvider } from './export.service'

export const EXPORT_SERVICES_MODULE_NAME = 'simax.services.export'

const module = angular.module(EXPORT_SERVICES_MODULE_NAME, [])

module.provider(EXPORT_SERVICE_NAME, ExportServiceProvider)
